export enum ESellerTypes {
  'Wholesale' = 'Wholesale',
  'Private Label' = 'Private Label',
  'Arbitrage' = 'Arbitrage',
  'Dropshipping' = 'Dropshipping',
  'Other' = 'Other',
}

export enum ESellerStore {
  'amazon' = 'amazon',
  'ebay' = 'ebay',
  'shopify' = 'shopify',
  'walmart' = 'walmart',
  'wix' = 'wix',
  'other' = 'other',
}

export interface IBusiness {
  id: string;
  name: string;
  sellerId: string;
  sellerType: ESellerTypes;
  sellerStore: ESellerStore;
  yearEstablished?: number;
  numEmployeesOld: number;
  storeUrl: string;
  monthlyRevenue: number;
  numProductsSold: number;
  influencerId: string;
  referralEmail?: string;
  featureFlag?: JSON;
  passedMinRevenue?: boolean;
  leadId?: string;
}

export interface IBussinesForUpdate {
  url_params_on_signup?: string;
  name?: string;
  seller_id?: string;
  seller_type?: ESellerTypes;
  seller_store?: ESellerStore;
  year_established?: number;
  num_employees_old?: string;
  store_url?: string;
  avg_monthly_revenue?: number;
  total_num_products_sold?: number;
  influencerName?: string;
  referralEmail?: string;
  passedMinRevenue?: boolean;
  lead_id?: string;
}
